import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import { useCreateResource } from '@app/src/api/updateHooks'
import { useAiJobs } from '@app/src/context/AiJobsContext'
import useErrorNotification from '@app/src/hooks/errorNotification'
import { useQueryClient } from '@tanstack/react-query'

type ScheduleEnrichmentPayload = {
  providerIds: number[]
  sendEmailOnComplete?: boolean
}

export const useScheduleEnrichment = () => {
  const { showErrorNotification } = useErrorNotification()
  const { mutateAsync: sendScheduleEnrichment, isPending: isScheduling } =
    useCreateResource<ScheduleEnrichmentPayload>()
  const queryClient = useQueryClient()
  const { addJob } = useAiJobs()

  const scheduleEnrichment = async (payload: ScheduleEnrichmentPayload) => {
    await sendScheduleEnrichment(
      {
        url: endpoints.scheduleEnrichment,
        body: payload,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: [FetchKey.ProviderCollection] })
          queryClient.invalidateQueries({ queryKey: [FetchKey.Provider] })
          queryClient.invalidateQueries({ queryKey: [FetchKey.ProviderCount] })
          queryClient.invalidateQueries({ queryKey: [FetchKey.ProviderFacets] })
          queryClient.invalidateQueries({ queryKey: [FetchKey.EligibleEnrichmentCount] })
          addJob({
            type: 'enrichment',
            inProgressCount: payload.providerIds.length,
            providerIds: payload.providerIds,
          })
        },
        onError: error => {
          showErrorNotification({ requestError: error, disableAutoClose: true })
        },
      },
    )
  }

  return { scheduleEnrichment, isScheduling }
}
